import {useEffect} from "react";
import ReCaptchaAction from "../enums/reCaptchaAction.enum";
import {EnvironmentConfig} from "../configs/environment.config";

const useReCaptcha = (action : ReCaptchaAction) => {

    useEffect(() => {
        if(!EnvironmentConfig.ReCaptchaEnable)
        {
            return;
        }

        const script = document.createElement('script');
        script.src = `${EnvironmentConfig.ReCaptchaUrl}${EnvironmentConfig.ReCaptchaClientId}`;
        document.body.appendChild(script);

        return () => {
            script.remove();
        };
    }, []);

    const getReCaptchaToken = async () : Promise<string| null> => {
        if(!EnvironmentConfig.ReCaptchaEnable)
        {
            return null;
        }

        return await window.grecaptcha.execute(EnvironmentConfig.ReCaptchaClientId, {action: action});
    };
    
    return {
        getReCaptchaToken
    };
};

export default useReCaptcha;